import { BaseEncoder } from "./BaseEncoder";
import { BaseObjectEncoder } from "./BaseObjectEncoder";
import { DefaultBaseObjectEncoderImpl } from "./DefaultBaseObjectEncoderImpl";

import { OpsExcInfoImpl } from "../model/impl/OpsExcInfoImpl";
import { Encodable } from "../model/Encodable";

import * as CubiqTS from "../index";

export class OpsExcInfoImplEncoder implements BaseEncoder {
  public baseEncoder: BaseObjectEncoder = new DefaultBaseObjectEncoderImpl();

  private static _instance;

  private constructor() {}

  public static get Instance() {
    // Do you need arguments? Make it a regular method instead.
    return this._instance || (this._instance = new this());
  }

  public encode(encodable: OpsExcInfoImpl, streamout: CubiqTS.ByteBuffer): void {
    this.baseEncoder.encode(encodable, streamout);

    this.baseEncoder.writeStartEncoding(streamout);

    /*Object encoding*/
    if (encodable.opsException != null) {
      this.baseEncoder.writeStartFid(1, streamout);
      this.baseEncoder.writeObject(
        false,
        OpsExcInfoImplEncoder.fidTypeMap.get(1),
        true,
        encodable.opsException,
        streamout,
      );
      this.baseEncoder.writeEndFid(1, streamout);
    }
    /*Object encoding*/
    if (encodable.exceptionId != null) {
      this.baseEncoder.writeStartFid(2, streamout);
      this.baseEncoder.writeObject(
        false,
        OpsExcInfoImplEncoder.fidTypeMap.get(2),
        false,
        encodable.exceptionId,
        streamout,
      );
      this.baseEncoder.writeEndFid(2, streamout);
    }
    /*Object encoding*/
    if (encodable.orderData != null) {
      this.baseEncoder.writeStartFid(3, streamout);
      this.baseEncoder.writeObject(
        false,
        OpsExcInfoImplEncoder.fidTypeMap.get(3),
        true,
        encodable.orderData,
        streamout,
      );
      this.baseEncoder.writeEndFid(3, streamout);
    }
    /*Object encoding*/
    if (encodable.deal != null) {
      this.baseEncoder.writeStartFid(4, streamout);
      this.baseEncoder.writeObject(
        false,
        OpsExcInfoImplEncoder.fidTypeMap.get(4),
        true,
        encodable.deal,
        streamout,
      );
      this.baseEncoder.writeEndFid(4, streamout);
    }
    /*Object encoding*/
    if (encodable.transactionData != null) {
      this.baseEncoder.writeStartFid(5, streamout);
      this.baseEncoder.writeObject(
        false,
        OpsExcInfoImplEncoder.fidTypeMap.get(5),
        true,
        encodable.transactionData,
        streamout,
      );
      this.baseEncoder.writeEndFid(5, streamout);
    }
    /*Object encoding*/
    if (encodable.messageId != null) {
      this.baseEncoder.writeStartFid(100, streamout);
      this.baseEncoder.writeObject(
        false,
        OpsExcInfoImplEncoder.fidTypeMap.get(100),
        false,
        encodable.messageId,
        streamout,
      );
      this.baseEncoder.writeEndFid(100, streamout);
    }
    /*Object encoding*/
    if(encodable.sessionOnly!=null){
        this.baseEncoder.writeStartFid(10010,streamout);
        this.baseEncoder.writeObject(false,OpsExcInfoImplEncoder.fidTypeMap.get(10010),false,encodable.sessionOnly,streamout);
        this.baseEncoder.writeEndFid(10010,streamout);
    }
    this.baseEncoder.writeEndEncoding(streamout);
  }

  static fidTypeMap: Map<number, string> = new Map<number, string>([
    [1, "com.bcdfx.model.OpsExcRecord"],
    [2, "java.lang.Long"],
    [3, "com.bcdfx.model.event.lifecycle.fx.OrderData"],
    [4, "com.bcdfx.model.Deal"],
    [5, "com.bcdfx.model.Errors"],
    [100, "java.lang.String"],
    [10010, "java.lang.String"],
  ]);

  /**
   * Constructs the event from a given byte stream
   */
  public decode(encodable: OpsExcInfoImpl, streamin: CubiqTS.ByteBuffer): void {
    this.baseEncoder.decode(encodable, streamin);

    while (true) {
      let ct: string = this.baseEncoder.readCtrl(streamin);
      if (ct == "^F") {
        break;
      }
      if (ct == "^H") continue;
      let fid: number = this.baseEncoder.parseCtrlAsFid(ct);
      if (this.supportsFid(fid) == false) this.baseEncoder.seekToNextFid(fid, streamin);
      switch (fid) {
        case 1: {
          /*Object encoding*/
          let val: CubiqTS.OpsExcRecord = this.baseEncoder.readObject(
            true,
            false,
            OpsExcInfoImplEncoder.fidTypeMap.get(1),
            streamin,
          );
          encodable.opsException = <CubiqTS.OpsExcRecord>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 2: {
          /*Object encoding*/
          let val: CubiqTS.Long = this.baseEncoder.readObject(
            false,
            false,
            OpsExcInfoImplEncoder.fidTypeMap.get(2),
            streamin,
          );
          encodable.exceptionId = <CubiqTS.Long>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 3: {
          /*Object encoding*/
          let val: CubiqTS.OrderData = this.baseEncoder.readObject(
            true,
            false,
            OpsExcInfoImplEncoder.fidTypeMap.get(3),
            streamin,
          );
          encodable.orderData = <CubiqTS.OrderData>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 4: {
          /*Object encoding*/
          let val: CubiqTS.Deal = this.baseEncoder.readObject(
            true,
            false,
            OpsExcInfoImplEncoder.fidTypeMap.get(4),
            streamin,
          );
          encodable.deal = <CubiqTS.Deal>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 5: {
          /*Object encoding*/
          let val: CubiqTS.Errors = this.baseEncoder.readObject(
            true,
            false,
            OpsExcInfoImplEncoder.fidTypeMap.get(5),
            streamin,
          );
          encodable.transactionData = <CubiqTS.Errors>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 100: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            OpsExcInfoImplEncoder.fidTypeMap.get(100),
            streamin,
          );
          encodable.messageId = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 10010:
        {
            /*Object encoding*/
            let val_10010:string=this.baseEncoder.readObject(false,false,OpsExcInfoImplEncoder.fidTypeMap.get(10010),streamin);
            encodable.sessionOnly=val_10010;
            this.baseEncoder.readEndFid(streamin);
            break;
        }
      }
    }
  }

  private supportsFid(fid: number): boolean {
    return OpsExcInfoImplEncoder.fidTypeMap.has(fid);
  }
}
